import { useState, useEffect } from "react";
import swal from "sweetalert2";
import { getUserGuestAllData } from "../api/reportsAPI";
import moment from "moment";

const GuestReport = (props) => {
  const [isInit, setIsInit] = useState(true);
  const [guestReport, setGuestReport] = useState(null);
  const [GuestTable, setBookingTable] = useState(null);

  useEffect(() => {
    props.title("Guest Report", "guest-report");
    getAllGuest();
  }, []);

  useEffect(() => {
    if (!isInit && guestReport) {
      fillTable();
    }
  }, [guestReport]);

  const getAllGuest = async () => {
    try {
      swal.fire({
        titleText: "Loading",
        text: "Please Wait. .. ",
        showConfirmButton: false,
        onOpen: () => {
          swal.showLoading();
        },
      });
      const response = await getUserGuestAllData();

      isInit ? setIsInit(false) : $("#tblTeeReport").KTDatatable().destroy();

      const userGuest = response?.BookSheet;
      console.log(userGuest || []);
      setGuestReport(userGuest || []);
    } catch (err) {
      console.error("Error fetching data:", err);
      swal.fire({
        icon: "error",
        titleText: err.message,
      });
    }
  };

  function fillTable() {
    swal.close();
    const $table = $("#tblUserGuestReport");
    if ($table.data("KTDatatable")) {
      $table.KTDatatable().destroy();
    }

    const tblGuestSheet = $("#tblUserGuestReport").KTDatatable({
      data: {
        saveState: false,
        source: guestReport,
      },
      layout: {
        scroll: true,
        footer: false,
      },
      sortable: false,
      pagination: false,
      search: {
        input: $("#generalSearch"),
      },
      columns: [
        { title: "Name", field: "Name" },
        { title: "Mobile", field: "Mobile" },
        { title: "Email", field: "Email" },
      ],
      rows: {
        autoHide: false,
      },
    });

    $("#root .kt-grid--hor").addClass("max-width100");
    $("#tblGuestSheet .kt-datatable__table").addClass("overflow-x-auto");

    Config.Core.InitPopover();
    Config.Core.GrabAndScroll(".kt-datatable__table");

    const fileName = `${moment().format("DD-MM-YYYY")} - Cash Card Report`;

    const BookingTable = $(".kt-datatable__table").tableExport({
      formats: ["xlsx", "csv"],
      headers: true,
      filename: fileName,
    });

    setBookingTable(BookingTable);
    $(".tableexport-caption").addClass("hidden");
  }

  function exportSheet(type) {
    const fileName = `${moment().format("DD-MM-YYYY")} - Guest Report`;

    GuestTable.update({
      headers: true,
      formats: ["xlsx", "csv"],
      filename: fileName, // pass in a new set of properties
    });

    if (type == "xlsx") {
      $(".button-default.xlsx").click();
    } else {
      $(".button-default.csv").click();
    }
    $(".tableexport-caption").addClass("hidden");
  }

  return (
    <>
      <div
        className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0"
        id="kt_content"
      >
        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
          <div className="kt-portlet">
            <div className="kt-portlet__body padding-t20 padding-b0">
              <div
                id="ControlHolder"
                className="kt-form kt-form--label-right padding-10"
                role="form"
              >
                <div className="row d-flex justify-content-end">
                  <div className="form-group col-sm-2">
                    <div className="input-group">
                      <div className="kt-input-icon kt-input-icon--left">
                        <input
                          type="text"
                          className="form-control clientSearch"
                          placeholder="Search..."
                          id="generalSearch"
                        />
                        <span className="kt-input-icon__icon kt-input-icon__icon--left">
                          <span>
                            <i className="la la-search"></i>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-1">
                    <div className="dropdown">
                      <button
                        className="btn btn-label-brand dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Export
                      </button>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                        x-placement="bottom-start"
                        style={{
                          position: "absolute",
                          willChange: "transform",
                          top: "0px",
                          left: "0px",
                          transform: "translate3d(0px, 38px, 0px)",
                        }}
                      >
                        <button
                          id="btn-export-excel"
                          type="button"
                          className="dropdown-item"
                          onClick={() => exportSheet("xlsx")}
                        >
                          {" "}
                          Excel
                        </button>
                        <button
                          id="btn-export-csv"
                          type="button"
                          className="dropdown-item"
                          onClick={() => exportSheet("csv")}
                        >
                          {" "}
                          Csv{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="tblUserGuestReport"
                className="table table-bordered table-hover custom-datatable"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuestReport;
